<template>
  <div class="serchProduct flex">
    <div class="btnText">
      <el-button type="text">最新产品</el-button>
      <el-button type="text">热门产品</el-button>
    </div>
    
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      input: "",
    };
  },
  components: {},
  methods: {
    queryInfoData() {
      console.log(this.input);
      if (this.input !== "") {
        this.$store.state.isSearch = true;
        this.$store.state.searchInput = this.input;
      } else {
        console.log(1);
        this.$emit("update:getData", this.input);
        // this.$store.state.isGetData = true;
      }
    },
  },
};
</script>
<style>
.search .el-input__inner {
  border-radius: 0;
  border-right: 0;
  color: #191f2f;
}
.search .el-button {
  width: 60px;
  height: 32px;
  vertical-align: middle;
  box-sizing: border-box;
  border-radius: 0;
  background-color: #49bbb9;
  border-color: #49bbb9;
  color: #ffffff;
  font-size: 16px;
  text-align: center;
}
</style>
<style scoped lang="less">
.serchProduct {
  width: 100%;
  height: 155px;
  line-height: 155px;
  background-color: #f0f1f3;
  .search {
    width: 360px;
    margin-left: 500px;
    .el-input {
      width: 260px;
      border-radius: 0;
    }
  }
  .btnText {
    margin-left: 300px;
    .el-button {
      color: #000;
      font-size: 28px;
      font-family: "Microsoft YaHei";
      letter-spacing: 2px;
      margin-right: 120px;
    }
  }
}
</style>
